import styled, { css } from 'styled-components'
import { TileFooter } from '@placeme/components/atoms'
import { useTranslation } from 'react-i18next'

import React from 'react'
import { AlabAttractivenessFormDataObject, FormFieldValue } from './@types/IAlabAttractivenessTileData'
import { AttractivenessFormElementWrapper } from '../Potential/Attractiveness/AttractivenessForm/AttractivenessFormElementWrapper'

interface IAlabAttractivenessFormProps {
  formDataObject: AlabAttractivenessFormDataObject
  setFormValue: (key: string, value: FormFieldValue) => void
  handleSubmit: () => void
  handleDeleteTile: () => void
  areAllFieldsFilled: boolean
}

const Description = styled.div(({
  theme: {
    palette, typography,
  },
}) => css`
  display: flex;
  align-items: center;
  color: ${palette.black};
  font-size: ${typography.small.pt_13_regular.fontSize};
  font-weight: ${typography.small.pt_13_regular.fontWeight};
  line-height: ${typography.small.pt_13_regular.lineHeight};

  > svg {
    margin-right: 1rem;
    min-width: 40px;
  }
`)

const DescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1.5rem;
`

export const AlabAttractivenessForm: React.FC<IAlabAttractivenessFormProps> = ({
  handleSubmit,
  handleDeleteTile,
  setFormValue,
  areAllFieldsFilled,
  formDataObject,
}) => {
  const { t } = useTranslation()
  const { formElementData } = formDataObject

  return (
    <>
      <DescriptionWrapper>
        <Description>{t('placeme.attractiveness.alab.tile.description_1')}</Description>
      </DescriptionWrapper>

      <AttractivenessFormElementWrapper
        elements={formElementData}
        setFormValue={setFormValue}
      />
      <TileFooter
        disabled={!areAllFieldsFilled}
        isUnlimited
        label={t('generic.apply')}
        onAccept={handleSubmit}
        onCancel={handleDeleteTile}
        value='1'
      />
    </>
  )
}
